export default function genererReglement() {
  return {
    dateReglement: null,
    montantTtc: null,
    emetteur: '',
    referenceReglement: '',
    dateEffet: null,
    remiseBancaireId: '',
    tiersId: '',
  };
}
